import { ICenter } from '../center';

export interface IQaRegistrationGetCentersResponse {
    data: {
        success: boolean,
        results: ICenter[]
    }
}